import { RouterStore } from "Config/CustomBrowserRouter";
import { projectsDataStore } from "Stores";

export function locateFileInViews(viewId: number, fileId: number) {
  RouterStore.push(`/project/${projectsDataStore.projectId}/views/?fileId=${fileId}&viewId=${viewId}`);
}
